import { render, staticRenderFns } from "./dashboard-sale-report.vue?vue&type=template&id=689d59ed&scoped=true&"
import script from "./dashboard-sale-report.vue?vue&type=script&lang=js&"
export * from "./dashboard-sale-report.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sale-report.vue?vue&type=style&index=0&id=689d59ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689d59ed",
  null
  
)

export default component.exports